import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import {
  FaBrain,
  FaChild,
  FaUserInjured,
  FaUser,
  FaUsers,
  FaDog,
  FaMicroscope,
  FaBookOpen,
} from "react-icons/fa";

export default function Statistics() {
  const stats = [
    {
      label: "Epilepsy Types",
      value: 50,
      description: "Types of epilepsy represented in studies.",
      icon: <FaBrain />,
    },
    {
      label: "Pediatric Studies",
      value: 51,
      description: "Number of pediatric studies examined.",
      icon: <FaChild />,
    },
    {
      label: "Adult Studies ",
      value: 15,
      description: "Number of adult studies examined.",
      icon: <FaUserInjured />,
    },
    {
      label: "Healthy Controls",
      value: 494,
      description: "Total number of individuals without epilepsy for comparison.",
      icon: <FaUser />,
    },
    {
      label: "Patients",
      value: 1051,
      description: "Total number of patients included in epilepsy studies.",
      icon: <FaUsers />,
    },
    {
      label: "Animal Species Studied",
      value: 4,
      description: "Rat, mouse, dog, and fruit fly used in epilepsy research.",
      icon: <FaDog />,
    },
    {
      label: "Countries Involved",
      value: 15,
      description: "Number of countries contributing to studies in SeizureDB.",
      icon: <FaMicroscope />,
    },
    {
      label: "Total Number of Literatures",
      value: 81,
      description: "Published papers indexed in the database.",
      icon: <FaBookOpen />,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      style={{
        padding: "3rem 2rem",
        maxWidth: "1100px",
        margin: "0 auto",
        fontFamily: "Segoe UI, sans-serif",
      }}
    >
      <motion.h1
        style={{
          textAlign: "center",
          fontSize: "2.4rem",
          color: "#0079C0",
          marginBottom: "2.5rem",
        }}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Portal Statistics
      </motion.h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "2rem",
        }}
      >
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 + index * 0.1 }}
            style={{
              backgroundColor: "#F5FAFF",
              padding: "1.8rem",
              borderRadius: "14px",
              border: "1px solid #ddeaf6",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "2rem",
                color: "#0079C0",
                marginBottom: "1rem",
              }}
            >
              {stat.icon}
            </div>

            <div
              style={{
                fontSize: "1.2rem",
                color: "#0066b2",
                fontWeight: 600,
                marginBottom: "0.3rem",
              }}
            >
              {stat.label}
            </div>

            <div
              style={{
                fontSize: "2.2rem",
                fontWeight: "bold",
                color: "#0079C0",
              }}
            >
              <CountUp end={stat.value} duration={2} />
            </div>

            <p
              style={{
                color: "#555",
                fontSize: "0.95rem",
                marginTop: "0.5rem",
                lineHeight: 1.4,
              }}
            >
              {stat.description}
            </p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}